import styled from 'styled-components';

export const ProjectsSectionComponent  = styled.div`
   display: block;
   margin: 20px auto;
   text-align: center;
`;

export const ProjectsSectionTitle  = styled.h4`
    margin: 0;
    padding: 0;
    color: #343333;
    font-size: 18px;    
    font-weight: 400;
    font-family: 'Oswald', sans-serif;
`;

export const ProjectsSectionDescription  = styled.h5`
    margin: 5px 0;
    color: #343333;
    font-size: 14px;
    font-weight: 300;
    font-family: 'Open Sans', sans-serif;
    display: block;
`;

export const ProjectsSectionBuiltWith = styled.p`
    font-family: 'Open Sans', sans-serif;
    font-style: italic;
    font-size: 12px;
`;
